import ApiService from "./api.service";

export const PermissionsService = {
    fetchAll() {
        return ApiService.get("permissions");
    }
};
